import React from 'react'

function Home() {
    return (
        <div className="container-fluid">
            <div className="home">
                <div className="row">
                    <div className="col-md-4 offset-4">
                       <div className="card card-body">
                       <h4 className="text-center">Quiz App</h4>

                       
         
                       </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
